module.exports = __webpack_public_path__ + "static/media/ic_latipay.22ddf86c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_latipay.svg
// module id = 123
// module chunks = 0